const permissions = {
  header: 'תפקידים והרשאות',
  notice: 'שינויים ישפיעו על משתמשים עם תפקידים תואמים בכל אתרי החברה.',
  toast: {
    delete: 'תפקיד נמחק והוקצה בהצלחה',
    error: 'משהו השתבש',
  },
  actions: {
    save: {
      button: 'שמור שינויים',
      confirmModal: {
        title: 'אישור',
        content: 'האם אתה בטוח שברצונך לשמור את השינויים?',
        confirm: 'אשר',
      },
      error: 'אירעה שגיאה בעת עדכון ההרשאות.',
      success: 'ההרשאות עודכנו בהצלחה!',
    },
    search: {
      placeholder: 'חפש...',
    },

    delete: {
      deleteBtn: 'מחק',
    },
    history: {
      historyBtn: 'היסטוריה',
    },
  },
  roleCard: {
    actions: {
      default: {
        label: 'ברירת מחדל',
        title: 'שחזר הרשאות ברירת מחדל לתפקיד "{{ name }}"',
        text: 'בהמשך\nתחזיר את התפקיד להרשאות ברירת המחדל',
        confirm: 'אשר',
        success: 'הרשאות ברירת המחדל לתפקיד שוחזרו בהצלחה.',
        failure: 'לא ניתן לשחזר הרשאות תפקיד עקב שגיאה בלתי צפויה.',
      },
      delete: {
        title: 'מחק תפקידים',
        deletionEnabled: 'אתה עומד למחוק תפקיד אחד',
        deletionDisabled: 'לא ניתן למחוק תפקיד עם {{ count }} משתמשים מחוברים. אנא הסר משתמשים לפני המחיקה',
      },
    },
    select: {
      all: 'הגדר את כל ההרשאות',
      none: 'בטל את כל ההרשאות',
    },
    count: '{{ count }} משתמשים',
  },
  addRoleCard: {
    title: 'הוסף +',
    createMode: {
      label: 'שם:',
    },
  },
  scope: {
    Holidays: 'חגים',
    MissionControl: 'מרכז השליטה',
    Timeline: 'ציר זמן',
    OnlineDrivers: 'נהגים מקוונים',
    Reservations: 'הזמנה',
    LiveMap: 'מפה חיה',
    Settings: 'הגדרות',
    SettingsTemplates: 'תבניות להגדרות',
    Vehicles: 'רכבים',
    Trips: 'נסיעות',
    Suppliers: 'ספקים',
    Shuttles: 'שאטלים',
    Shifts: 'משמרות',
    Services: 'שירותים',
    'תפקידים והרשאות': 'תפקידים והרשאות',
    Reports: 'דוחות',
    Rates: 'תעריפים',
    Profiles: 'פרופילים',
    Passengers: 'נוסעים',
    Parent: 'הורה',
    Users: 'משתמשים',
    Locations: 'מיקומים',
    Integrations: 'אינטגרציות',
    Fares: 'דמי נסיעה',
    ExtraServices: 'שירותים נוספים',
    Drivers: 'נהגים',
    DriverShifts: 'משמרות נהגים',
    DataUpload: 'ייבא',
    Export: 'ייצא',
    CustomRules: 'כללים מותאמים',
    BlacklistCards: 'אמצעי תשלום חסומים',
    Automations: 'אוטומציות',
    Attributes: 'מאפיינים',
    Areas: 'אזורים',
  },
  sitesViewError: 'עבור לתצוגת אתר יחיד כדי לגשת לדף זה',
};

export default permissions;
